import { createSlice } from "@reduxjs/toolkit";

export const getCloudBucketSlice = createSlice({
    name: "getCloudBucketDetails",
    initialState: {
        getCloudBucketData: [],
    },

    reducers: {
        setGetCloudBucketData: (state, action) => {
            state.getCloudBucketData = action.payload;
        },
    },
});

export const { setGetCloudBucketData } = getCloudBucketSlice.actions;

export default getCloudBucketSlice.reducer;